import * as React from 'react';
import { Button, Modal, Select } from '@teamsnap/teamsnap-ui';
import './edit-participant-modal.scss';
import { Member } from 'models';
import { TEAMSNAP_URL } from 'core/constants';

type Props = {
  member: Member;
  show: boolean;
  setShow: (x: boolean) => void;
};

const displayName = ({ firstName, lastName }) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  return firstName ? firstName : lastName;
};

const EditModal = ({ show, setShow, member }: Props) => {
  const [participationSelected, setParticipationSelected] = React.useState<number>(
    member.seasonParticipants[0].seasonParticipantId
  );

  const handleClick = () => {
    const participation = member.seasonParticipants.find((x) => x.seasonParticipantId === participationSelected);

    window.open(`${TEAMSNAP_URL}/${participation.division.id}/league_roster/player/${participationSelected}`);
  };

  return (
    <Modal
      heading="Edit Participant"
      style={{ minWidth: '0', width: '451px', textAlign: 'start' }}
      show={show}
      showClose
      closeFn={() => setShow(false)}
    >
      <div>
        <div>
          {member.seasonParticipants.length > 1 ? (
            <>
              <p className="u-textLeft">Which {displayName(member)} profile would you like to edit?</p>

              <Select
                name="from"
                mods="u-spaceTopMd"
                options={member.seasonParticipants.map((x) => ({
                  value: x.seasonParticipantId,
                  label: `${x.team?.name ?? 'No Team'} (${x.division?.name ?? 'No Division'})`,
                }))}
                inputProps={{
                  value: participationSelected,
                  onChange: (e) => setParticipationSelected(parseInt(e.target.value)),
                }}
              />
            </>
          ) : (
            <>
              <p className="u-textLeft">Do you wish to edit {displayName(member)}'s roster profile?</p>
            </>
          )}

          <div className="buttons-wrapper">
            <Button mods="u-spaceRightSm" onClick={() => setShow(false)}>
              Cancel
            </Button>
            <Button mods="Button Button--primary" onClick={handleClick}>
              Edit
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditModal;
